export const REPORT_KINDS = [
  { value: "PARAMETERIZED", label: "Parameterized" },
  { value: "NARRATIVE", label: "Narrative" },
];

export const FIELD_TYPES = [
  { value: "NUMBER", label: "Number" },
  { value: "TEXT", label: "Text" },
  { value: "BOOLEAN", label: "Boolean" },
  { value: "SELECT", label: "Select" },
];

export const DEFAULT_REPORT_KIND = "PARAMETERIZED";
export const DEFAULT_FIELD_TYPE = "NUMBER";

export const DROPDOWN_FIELD_TYPE = "SELECT";

export const REFERENCE_RANGE_GENDERS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
];

export const genderLabel = (value) =>
  REFERENCE_RANGE_GENDERS.find((g) => g.value === value)?.label || value || "-";

export const DROPDOWN_OPTION_PRESETS = [
  ["Reactive", "Non-Reactive"],
  ["Positive", "Negative"],
  ["Detected", "Not Detected"],
  ["Normal", "Abnormal"],
];

export const MAX_DROPDOWN_OPTIONS = 50;

export const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const reportKindLabel = (value) =>
  REPORT_KINDS.find((k) => k.value === value)?.label || value || "-";
